// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"81a7c180","806":"8ee711a2"}[chunkId] + ".chunk.js";
};